import React from "react";
import { Grid, Segment, Label, Message } from "semantic-ui-react";
import _ from "lodash";
import { socket } from "../../../lib/socketio";

// [UPDATE] BUGFIX display alarm label, 250813
import { useSelector, useDispatch } from "react-redux";
import { setIsAlarmSetMAIN, setIsAlarmSetPSM1, setIsAlarmSetPSM2, setIsAlarmSetPSM3, setIsAlarmSetPSM4, setIsAlarmSetPSM5,
  setPrevAlarmMAIN, setPrevAlarmPSM1, setPrevAlarmPSM2, setPrevAlarmPSM3, setPrevAlarmPSM4, setPrevAlarmPSM5
} from "../../../actions/DataActions";

const PlantOvrColumn = ({ index, column, data, option, tagid, currAlarmMAIN, currAlarmPSM1, currAlarmPSM2, currAlarmPSM3, currAlarmPSM4, currAlarmPSM5 }) => {

  // [UPDATE] BUGFIX display alarm label, 250813
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const [tagdata, settagdata] = React.useState("");
  // update 241211, Shutdown Highlighting
  const [overrideVisible, setOverrideVisible] = React.useState({'visible' : true});
  // [UPDATE] BUGFIX display alarm label, 250813
  const isAlarmSetMAIN = useSelector(state => state.data.isAlarmSetMAIN);
  const isAlarmSetPSM1 = useSelector(state => state.data.isAlarmSetPSM1);
  const isAlarmSetPSM2 = useSelector(state => state.data.isAlarmSetPSM2);
  const isAlarmSetPSM3 = useSelector(state => state.data.isAlarmSetPSM3);
  const isAlarmSetPSM4 = useSelector(state => state.data.isAlarmSetPSM4);
  const isAlarmSetPSM5 = useSelector(state => state.data.isAlarmSetPSM5);
  const prevAlarmMAIN = useSelector(state => state.data.prevAlarmMAIN);
  const prevAlarmPSM1 = useSelector(state => state.data.prevAlarmPSM1);
  const prevAlarmPSM2 = useSelector(state => state.data.prevAlarmPSM2);
  const prevAlarmPSM3 = useSelector(state => state.data.prevAlarmPSM3);
  const prevAlarmPSM4 = useSelector(state => state.data.prevAlarmPSM4);
  const prevAlarmPSM5 = useSelector(state => state.data.prevAlarmPSM5);

  // [UPDATE] Plant Overview alarm display, 250703
  // const [prevAlarmMAIN, setPrevAlarmMAIN] = React.useState();
  // const [prevAlarmPSM1, setPrevAlarmPSM1] = React.useState();
  // const [prevAlarmPSM2, setPrevAlarmPSM2] = React.useState();
  // const [prevAlarmPSM3, setPrevAlarmPSM3] = React.useState();
  // const [prevAlarmPSM4, setPrevAlarmPSM4] = React.useState();
  // const [prevAlarmPSM5, setPrevAlarmPSM5] = React.useState();
  // const [isAlarmSetMAIN, setIsAlarmSetMAIN] = React.useState(false);
  // const [isAlarmSetPSM1, setIsAlarmSetPSM1] = React.useState(false);
  // const [isAlarmSetPSM2, setIsAlarmSetPSM2] = React.useState(false);
  // const [isAlarmSetPSM3, setIsAlarmSetPSM3] = React.useState(false);
  // const [isAlarmSetPSM4, setIsAlarmSetPSM4] = React.useState(false);
  // const [isAlarmSetPSM5, setIsAlarmSetPSM5] = React.useState(false);

  // [UPDATE] Plant Overview alarm display, 250703
  // [UPDATE] BUGFIX display alarm label, 250813
  // * prevAlarm 값 초기화
  React.useEffect(() => {
    dispatch(setPrevAlarmMAIN(currAlarmMAIN));
    dispatch(setPrevAlarmPSM1(currAlarmPSM1));
    dispatch(setPrevAlarmPSM2(currAlarmPSM2));
    dispatch(setPrevAlarmPSM3(currAlarmPSM3));
    dispatch(setPrevAlarmPSM4(currAlarmPSM4));
    dispatch(setPrevAlarmPSM5(currAlarmPSM5));
    // setPrevAlarmMAIN(currAlarmMAIN);
    // setPrevAlarmPSM1(currAlarmPSM1);
    // setPrevAlarmPSM2(currAlarmPSM2);
    // setPrevAlarmPSM3(currAlarmPSM3);
    // setPrevAlarmPSM4(currAlarmPSM4);
    // setPrevAlarmPSM5(currAlarmPSM5);
  }, []);

  // [UPDATE] Plant Overview alarm display, 250703
  // [UPDATE] BUGFIX display alarm label 250813
  // [UPDATE] BUGFIX calculate alarm (!== -> <)
  // * alarm set 동작
  React.useEffect(() => {
    if(prevAlarmMAIN !== null && (prevAlarmMAIN < currAlarmMAIN) && !isAlarmSetMAIN){
      dispatch(setIsAlarmSetMAIN(true));
    }
    if (prevAlarmPSM1 !== null && (prevAlarmPSM1 < currAlarmPSM1) && !isAlarmSetPSM1) {
      dispatch(setIsAlarmSetPSM1(true));
    }

    if (prevAlarmPSM2 !== null && (prevAlarmPSM2 < currAlarmPSM2) && !isAlarmSetPSM2) {
      dispatch(setIsAlarmSetPSM2(true));
    }

    if (prevAlarmPSM3 !== null && (prevAlarmPSM3 < currAlarmPSM3) && !isAlarmSetPSM3) {
      dispatch(setIsAlarmSetPSM3(true));
    }

    if (prevAlarmPSM4 !== null && (prevAlarmPSM4 < currAlarmPSM4) && !isAlarmSetPSM4) {
      dispatch(setIsAlarmSetPSM4(true));
    }

    if (prevAlarmPSM5 !== null && (prevAlarmPSM5 < currAlarmPSM5) && !isAlarmSetPSM5) {
      dispatch(setIsAlarmSetPSM5(true));
    }
  }, [currAlarmMAIN, currAlarmPSM1, currAlarmPSM2, currAlarmPSM3, currAlarmPSM4, currAlarmPSM5 ]);

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 400);
    return() => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const setOverrideVisiblity = () => {
    setOverrideVisible({...overrideVisible, 'visible': !overrideVisible.visible});
  }

  // update 241111, display stack min/max temp
  const PSMMinTemp = 'STK MinTemp';
  const PSMMaxTemp = 'STK MaxTemp';

  const handleOpen = (event, id) => {
    setOpen({ ...open, [id]: true });
  };

  const handleClose = (id) => {
    settagdata("");
    setOpen({ ...open, [id]: false });
  };

  const handleSubmit = (event, value, id, min, max) => {
    event.preventDefault();
    if (typeof tagdata === "undefined" || tagdata === "") {
      setOpen({ ...open, [id]: false });
    } else {
      var writedata = [{ tag_id: id, tag_value: tagdata }];
      socket.emit("write tag", writedata);
      setOpen({ ...open, [id]: false });
    }
    settagdata("");
  };

  const handleChange = (event, value, id) => {
    event.preventDefault();
    settagdata(event.target.value);
  };

  const PStateMain = data[29129];
  const PStatePSM1 = data[6717];
  const PStatePSM2 = data[10631];
  const PStatePSM3 = data[14545];
  const PStatePSM4 = data[18459];
  const PStatePSM5 = data[22373];
  const WStateMain = data[29136];
  // update 240826, add KWACNetSUM display
  const kWACNetPSM1 = data[29630]; // PCS Active Power
  const kWACNetPSM2 = data[31037];
  const kWACNetPSM3 = data[32444];
  const kWACNetPSM4 = data[33851];
  const kWACNetPSM5 = data[35258];


  // update SOFC : 발전상태 표시 Label switch문 있는 함수로 변경
  const displayStateValue = (subgroup) => {
    switch(subgroup){
      case 'CBM/MAIN':
        return <Label circular color={getColorByWStateRange(WStateMain)} empty />
      case 'PSM1':
        return <Label circular color={getColorByPStateRange(PStatePSM1)} empty />
      case 'PSM2':
        return <Label circular color={getColorByPStateRange(PStatePSM2)} empty />
      case 'PSM3':
        return <Label circular color={getColorByPStateRange(PStatePSM3)} empty />
      case 'PSM4':
        return <Label circular color={getColorByPStateRange(PStatePSM4)} empty />
      case 'PSM5':
        return <Label circular color={getColorByPStateRange(PStatePSM5)} empty />
      default:
        return <></>
    }
  }

  const getColorByPStateRange = (value) => {
    if (value >=10 && value <=100){
      return 'green';
    }else if (value >= 110 && value <= 310){
      return 'yellow';
    }else if (value >= 400){
      return 'red';
    }
  }

  const getColorByWStateRange = (value) => {
    if (value >= 10 && value <= 100){
      return 'green';
    }else if (value > 100){
      return 'red';
    }
  }

  // update 241211, Shutdown Highlighting
  const getColorBySDStatus = (value) => {
    if(value >= 600 && value <= 650){
      return overrideVisible.visible ? 'red' : '';
    }
  }
  // update 241211, Shutdown Highlighting
  const displaySDStatus = (subgroup) => {
    switch(subgroup){
      case 'PSM1':
        return getColorBySDStatus(PStatePSM1);
      case 'PSM2':
        return getColorBySDStatus(PStatePSM2);
      case 'PSM3':
        return getColorBySDStatus(PStatePSM3);
      case 'PSM4':
        return getColorBySDStatus(PStatePSM4);
      case 'PSM5':
        return getColorBySDStatus(PStatePSM5);
      default:
        return <></>
    }
  }

  // update 240820, plant overview display
  const convertDigValue = (name, data) => {
    if(data === 1){
      return 'ON'
    }else{
      return 'OFF'
    }
  }

  // update 240826, add KWACNetSUM display
  const getSumKWACNET = (data1, data2, data3, data4, data5) => {
    data1 = data1 ?? 0;
    data2 = data2 ?? 0;
    data3 = data3 ?? 0;
    data4 = data4 ?? 0;
    data5 = data5 ?? 0;

    return data1 + data2 + data3 + data4 + data5;
  }

  // update 241111, display stack min/max temp
  const displayStkMinTemp = (column) => {
    let stkTagArr = [];
    let stkTempArr = [];
    let minTemp;

    stkTagArr = Object.values(column)[0].filter(c => c.hmi_controlloop_subdisplay === 'Stack').map(c => c.id);
    stkTempArr = stkTagArr.filter(c => data[c] > -31 && data[c] < 701).map(c => data[c]);

    if(stkTempArr.length > 0){
      minTemp = Math.min(...stkTempArr);
    }

    return minTemp;
  }

  const displayStkMaxTemp = (column) => {
    let stkTagArr = [];
    let stkTempArr = [];
    let maxTemp;

    stkTagArr = Object.values(column)[0].filter(c => c.hmi_controlloop_subdisplay === 'Stack').map(c => c.id);
    stkTempArr = stkTagArr.filter(c => data[c] > -31 && data[c] < 701).map(c => data[c]);

    if(stkTempArr.length > 0){
      maxTemp = Math.max(...stkTempArr);
    }

    return maxTemp;
  }

  // display PPC Version in plant overview column
  const displayPPCVersion = (subgroup) => {

    data['29146'] = data['29146'] ?? '';
    data['29147'] = data['29147'] ?? '';
    data['29148'] = data['29148'] ?? '';
    data['29149'] = data['29149'] ?? '';

    data['6734'] = data['6734'] ?? '';
    data['6735'] = data['6735'] ?? '';
    data['6736'] = data['6736'] ?? '';
    data['6737'] = data['6737'] ?? '';
    data['30074'] = data['30074'] ?? '';

    data['10648'] = data['10648'] ?? '';
    data['10649'] = data['10649'] ?? '';
    data['10650'] = data['10650'] ?? '';
    data['10651'] = data['10651'] ?? '';
    data['31481'] = data['31481'] ?? '';

    data['14562'] = data['14562'] ?? '';
    data['14563'] = data['14563'] ?? '';
    data['14564'] = data['14564'] ?? '';
    data['14565'] = data['14565'] ?? '';
    data['32888'] = data['32888'] ?? '';

    data['18476'] = data['18476'] ?? '';
    data['18477'] = data['18477'] ?? '';
    data['18478'] = data['18478'] ?? '';
    data['18479'] = data['18479'] ?? '';
    data['34295'] = data['34295'] ?? '';

    data['22390'] = data['22390'] ?? '';
    data['22391'] = data['22391'] ?? '';
    data['22392'] = data['22392'] ?? '';
    data['22393'] = data['22393'] ?? '';
    data['35702'] = data['35702'] ?? '';

    switch(subgroup){
      case 'CBM/MAIN':
        return <p>{(typeof data['29146'] !== 'undefined' && data['29146'] !== null)? (data['29146'] + '.' + data['29147'] + '.' + data['29148'] + '.' + data['29149']) : ''}</p>;
      case 'PSM1':
        return <p>{(typeof data['6734'] !== 'undefined' && data['6734'] !== null)? (data['6734'] + '.' + data['6735'] + '.' + data['6736'] + '.' + data['6737'] + '.' + data['30074']) : ''}</p>;
      case 'PSM2':
        return <p>{(typeof data['10648'] !== 'undefined' && data['10648'] !== null)? (data['10648'] + '.' + data['10649'] + '.' + data['10650'] + '.' + data['10651'] + '.' + data['31481']) : ''}</p>;
      case 'PSM3':
        return <p>{(typeof data['14562'] !== 'undefined' && data['14562'] !== null)? (data['14562'] + '.' + data['14563'] + '.' + data['14564'] + '.' + data['14565'] + '.' + data['32888']) : ''}</p>;
      case 'PSM4':
        return <p>{(typeof data['18476'] !== 'undefined' && data['18476'] !== null)? (data['18476'] + '.' + data['18477'] + '.' + data['18478'] + '.' + data['18479'] + '.' + data['34295']) : ''}</p>;
      case 'PSM5':
        return <p>{(typeof data['22390'] !== 'undefined' && data['22390'] !== null)? (data['22390'] + '.' + data['22391'] + '.' + data['22392'] + '.' + data['22393'] + '.' + data['35702']) : ''}</p>;
      default:
        return <></>
    }
  }

  // update SOFC 250604, display total override in plant overview page
  const displayTotalOverrides = (subgroup) => {
    if (subgroup  === 'MAIN'){
      return data[0];
    }else if (subgroup === 'PSM1'){
      return data[-1];
    }else if (subgroup === 'PSM2'){
      return data[-2];
    }else if (subgroup === 'PSM3'){
      return data[-3];
    }else if (subgroup === 'PSM4'){
      return data[-4];
    }else if (subgroup === 'PSM5'){
      return data[-5];
    }
  }

  // [UPDATE] Plant Overview alarm display, 250703
  // [UPDATE] BUGFIX display alarm label 250813
  const displayAlarmSet = (subgroup) => {
    switch(subgroup){
      case 'CBM/MAIN':
        return isAlarmSetMAIN;
      case 'PSM1':
        return isAlarmSetPSM1;
      case 'PSM2':
        return isAlarmSetPSM2;
      case 'PSM3':
        return isAlarmSetPSM3;
      case 'PSM4':
        return isAlarmSetPSM4;
      case 'PSM5':
        return isAlarmSetPSM5;
      default:
        return false;
    }
  }

  // [UPDATE] Plant Overview alarm display, 250703
  // [UPDATE] BUGFIX display alarm label 250813
  const handleAlarmLabelClick = (event, subgroup) => {
    switch(subgroup){
      case 'CBM/MAIN':
        dispatch(setIsAlarmSetMAIN(false));
        dispatch(setPrevAlarmMAIN(currAlarmMAIN));
        break;
      case 'PSM1':
        dispatch(setIsAlarmSetPSM1(false));
        dispatch(setPrevAlarmPSM1(currAlarmPSM1));
        break;
      case 'PSM2':
        dispatch(setIsAlarmSetPSM2(false));
        dispatch(setPrevAlarmPSM2(currAlarmPSM2));
        break;
      case 'PSM3':
        dispatch(setIsAlarmSetPSM3(false));
        dispatch(setPrevAlarmPSM3(currAlarmPSM3));
        break;
      case 'PSM4':
        dispatch(setIsAlarmSetPSM4(false));
        dispatch(setPrevAlarmPSM4(currAlarmPSM4));
        break;
      case 'PSM5':
        dispatch(setIsAlarmSetPSM5(false));
        dispatch(setPrevAlarmPSM5(currAlarmPSM5));
        break;
      default:
        break;
    }
  }

  // [UPDATE] factory request 202511 - display CLD ON Count
  const displayCLDCount = (column) => {

    let CLDArr = Object.values(column)[0].filter(c => c.hmi_controlloop_subdisplay === 'CLD').map(c => c.id);
    let CLDCount = CLDArr.reduce((acc, curr) => acc + (data[curr] ? 0 : 1), 0); // CLD 값 0 -> ON, 1 -> OFF

    return CLDCount;
  }

  // [UPDATE] factory request 202511 - decimal point
  const convertDecimalPoint = (id, bit) => {
    let value = data[id];

    if(typeof value !== 'undefined' && value !== null && bit !== null ){
      value = Number(value);
      return value.toFixed(bit);
    }else{
      return value;
    }

  }

  // [UPDATE] display PPLT Auxpower (InvkWAC - PPLT ACNet)
  const displayColumn = (column) => {
    const subdisplays = [...new Set(column.map(c => c.hmi_controlloop_subdisplay).filter(name => name !== null))];

    return(
        subdisplays.map(c =>
            <>
              <Grid.Row style={styles.header}>
                {c}
              </Grid.Row>
              {column.map((r) => (
                  r.id !== 1684 ?
                      r.hmi_controlloop_subdisplay === c &&
                      <Grid.Row colums={3} key={r.id} style={styles.row}>
                        <Grid.Column width={8} style={styles.name}>
                          {r.tag_display_name}
                        </Grid.Column>
                        <Grid.Column width={4} style={styles.value}>
                          {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : data[r.id]}{" "} {/** //update 240820, plant overview display */}
                        </Grid.Column>
                        <Grid.Column width={1}>{r.unit}</Grid.Column>
                      </Grid.Row>
                      :
                      // r.hmi_controlloop_subdisplay === c &&
                      // <Grid.Row colums={3} key={r.id} style={styles.row}>
                      //   <Grid.Column width={8} style={styles.name}>
                      //    PPLT AuxPower
                      //   </Grid.Column>
                      //   <Grid.Column width={4} style={styles.value}>
                      //     {displayPPLTAuxPower()}
                      //   </Grid.Column>
                      //   <Grid.Column width={1}></Grid.Column>
                      // </Grid.Row>
                      ''
              ))}
            </>

        )
    )

    // for (let title of subdisplays){
    //   return (
    //     <>
    //       <Grid.Row style={styles.header}>
    //         {title}
    //       </Grid.Row>
    //       {column.map((r) => (
    //         r.hmi_controlloop_subdisplay === title &&
    //         <Grid.Row colums={3} key={r.id} style={styles.row}>
    //           <Grid.Column width={8} style={styles.name}>
    //             {r.tag_display_name}
    //               </Grid.Column>
    //               <Grid.Column width={4} style={styles.value}>
    //                 {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : data[r.id]}{" "} {/** //update 240820, plant overview display */}
    //               </Grid.Column>
    //               <Grid.Column width={1}>{r.unit}</Grid.Column>
    //         </Grid.Row>
    //       ))}
    //     </>
    //   )
    // }
  }

  // [UPDATE] display PPLT Aux Power 260202
  const displayPPLTAuxPower = () => {
    const InvkWAC = parseInt(data[1684]);
    const AInKWACNet = parseInt(data[28834]);

    if(isNaN(InvkWAC) || isNaN(AInKWACNet)){
      return '';
    }

    return InvkWAC - AInKWACNet;
  }

  const gridColumn = _.times(1, (i) =>
      Object.keys(column).map((i) => (
          <>
            {/** // update 241217 Shutdown highlighting */}
            <Segment color={column[i][0].tag_display_subgroup.includes('PSM') ? displaySDStatus(column[i][0].tag_display_subgroup) : ''} style={{backgroundColor : '#1b1c1d'}} >
              {column[i][0].tag_display_subgroup === 'MAIN' ?
                  <Grid width='equal' style={styles.grid}>
                    <Grid.Row style={styles.header}>
                      {column[i][0].tag_display_subgroup} &nbsp;
                      {displayStateValue(column[i][0].tag_display_subgroup)}
                    </Grid.Row>

                    {column[i].map((r) => (
                        r.hmi_controlloop_subdisplay !== 'PPC VERSION' &&
                        <Grid.Row columns={3} key={r.id} style={styles.row}>
                          <Grid.Column width={8} style={styles.name}>
                            {r.tag_display_name}
                          </Grid.Column>
                          <>
                            <Grid.Column width={4} style={styles.value}>
                              {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : convertDecimalPoint(r.id, r.bit)}{" "} {/** //update 240820, plant overview display */}
                            </Grid.Column>
                          </>
                          <Grid.Column width={1}>{r.unit}</Grid.Column>
                          {/*//@ SOFC Plant Overview 버튼 추가 */}
                        </Grid.Row>
                    ))}

                    <Grid.Row columns={3} key={9991} style={styles.row}>
                      <Grid.Column width={8} style={styles.name}>
                        <p>kWACNet Sum</p>
                      </Grid.Column>
                      <Grid.Column width={4} style={styles.value}>
                        {getSumKWACNET(kWACNetPSM1, kWACNetPSM2, kWACNetPSM3, kWACNetPSM4, kWACNetPSM5).toFixed(2)}
                      </Grid.Column>
                      <Grid.Column width={1} style={styles.value}>
                        kW
                      </Grid.Column>
                    </Grid.Row>

                    {/** //@TEST : 250226, display ppc version  */}
                    <Grid.Row columns={3} key={9992} style={styles.row}>
                      <Grid.Column width={8} style={styles.name}>
                        <p>PPC Ver</p>
                      </Grid.Column>
                      <Grid.Column width={4} style={styles.value}>
                        {displayPPCVersion(column[i][0].tag_display_subgroup)}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                  : column[i][0].tag_display_subgroup.includes('PSM')?
                      <Grid width='equal' style={styles.grid}>
                        <Grid.Row style={styles.header}>
                          {/** // [UPDATE] Plant Overview alarm display, 250703  */}
                          {displayAlarmSet(column[i][0].tag_display_subgroup) ?
                              <Label color='yellow'  style={styles.alarmLabel} size = 'mini' onClick={(event) => handleAlarmLabelClick(event, column[i][0].tag_display_subgroup)}>ALARM</Label> : ''}
                          {/** //update 241211, Shutdown highlighting  */}
                          <p style={{ marginTop :'0px', marginBottom : '0px', color : displaySDStatus(column[i][0].tag_display_subgroup) }} >{column[i][0].tag_display_subgroup}&nbsp;</p>
                          {/* {column[i][0].tag_display_subgroup} &nbsp; */}
                          {displayStateValue(column[i][0].tag_display_subgroup)}
                        </Grid.Row>

                        <h4 style={{ marginTop : '0px', marginBottom : '0px', paddingLeft : '0px', color : '#DDDDDD'}}>STATE</h4>
                        {column[i].map((r) => (
                            (r.hmi_controlloop_subdisplay === 'STATE') &&
                            <Grid.Row colums={3} key={r.id} style={styles.row}>
                              <Grid.Column width={8} style={styles.name}>
                                {r.tag_display_name}
                              </Grid.Column>
                              <>
                                <Grid.Column width={4} style={styles.value}>
                                  {/* {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : data[r.id]}{" "} * //update 240820, plant overview display */}
                                  {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : convertDecimalPoint(r.id, r.bit)}{" "} {/** //update 240820, plant overview display */}
                                </Grid.Column>
                              </>
                              <Grid.Column width={1}>{r.unit}</Grid.Column>
                            </Grid.Row>
                        ))}

                        <h4 style={styles.subgroup}>TAGS</h4>
                        {column[i].map((r) => ( // update 241111, diplay minTemp
                            (r.hmi_controlloop_subdisplay !== 'Stack' && r.hmi_controlloop_subdisplay !== 'PPC VERSION' && r.hmi_controlloop_subdisplay !== 'CLD' && r.hmi_controlloop_subdisplay !== 'STATE') &&
                            <Grid.Row colums={3} key={r.id} style={styles.row}>
                              <Grid.Column width={8} style={styles.name}>
                                {r.tag_display_name}
                              </Grid.Column>
                              <>
                                <Grid.Column width={4} style={styles.value}>
                                  {/* {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : data[r.id]}{" "} * //update 240820, plant overview display */}
                                  {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) : convertDecimalPoint(r.id, r.bit)}{" "} {/** //update 240820, plant overview display */}
                                </Grid.Column>
                              </>
                              <Grid.Column width={1}>{r.unit}</Grid.Column>
                            </Grid.Row>
                        ))}

                        {/** [UPDATE] factory request - 202511*/}
                        {/* <Grid.Row columns={3} key={9991} style={styles.row}>
                <Grid.Column width={8} style={styles.name}>
                  <p>{PSMMinTemp}</p>
                </Grid.Column>
                <Grid.Column width={4} style={styles.value}>
                  {displayStkMinTemp(column)}
                </Grid.Column>
                <Grid.Column width={1} style={styles.value}>
                  C
                </Grid.Column>
              </Grid.Row>

              <Grid.Row columns={3} key={9992} style={styles.row}>
                <Grid.Column width={8} style={styles.name}>
                  <p>{PSMMaxTemp}</p>
                </Grid.Column>
                <Grid.Column width={4} style={styles.value}>
                  {displayStkMaxTemp(column)}
                </Grid.Column>
                <Grid.Column width={1} style={styles.value}>
                  C
                </Grid.Column>
              </Grid.Row> */}

                        {/** [UPDATE] factory request - 202511*/}
                        <Grid.Row columns={3} key={9900} style={styles.row}>
                          <Grid.Column width={8} style={styles.name}>
                            <p>CLD Count</p>
                          </Grid.Column>
                          <Grid.Column width={4} style={styles.value}>
                            {displayCLDCount(column)}
                          </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={3} key={9901} style={styles.row}>
                          <Grid.Column width={8} style={styles.name}>
                            <p>OVERRIDES</p>
                          </Grid.Column>
                          <Grid.Column width={4} style={styles.value}>
                            {displayTotalOverrides(column[i][0].tag_display_subgroup)}
                          </Grid.Column>
                        </Grid.Row>

                        <h4 style={styles.subgroup}>PPC VERSION</h4>
                        {/** display ppc version  */}
                        <Grid.Row columns={3} key={9902} style={styles.row}>
                          <Grid.Column width={8} style={styles.name}>
                            <p>PPC Ver</p>
                          </Grid.Column>
                          <Grid.Column width={4} style={styles.value}>
                            {displayPPCVersion(column[i][0].tag_display_subgroup)}
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      :
                      column[i][0].tag_display_subgroup === 'GROUP' ?
                          <Grid width='equal' style={styles.grid}>
                            {displayColumn(column[i])}
                          </Grid>
                          :
                          <Grid width='equal' style={styles.grid}>
                            <Grid.Row style={styles.header}>
                              {column[i][0].tag_display_subgroup} &nbsp;
                              {displayStateValue(column[i][0].tag_display_subgroup)}
                            </Grid.Row>
                            {column[i].map((r) => (
                                (r.hmi_controlloop_subdisplay !== 'Stack' && r.hmi_controlloop_subdisplay !== 'PPC VERSION' ) && // update 241111, display stack min/max temp
                                <Grid.Row colums={3} key={r.id} style={styles.row}>
                                  <Grid.Column width={8} style={styles.name}>
                                    {r.tag_display_name}
                                  </Grid.Column>
                                  <>
                                    <Grid.Column width={4} style={styles.value}>
                                      {r.datatype === 'Boolean'? convertDigValue(r.name, data[r.id]) :  convertDecimalPoint(r.id, r.bit)}{" "} {/** //update 240820, plant overview display */}
                                    </Grid.Column>
                                  </>
                                  <Grid.Column width={1}>{r.unit}</Grid.Column>
                                </Grid.Row>
                            ))}
                          </Grid>
              }
            </Segment>

          </>
      ))
  );

  return (
      <Grid.Column key={index} style={{ maxWidth: "2000px", padding: "10" }}>
        {gridColumn}
      </Grid.Column>
  );
};

const styles = {
  grid: {
    margin: "0",
    padding: "0",
    marginBottom: "0",
    maxWidth: "280px"
  },
  row: {
    padding: "2px 0",
  },
  name: {
    color: "yellow"
  },
  value : {
    color: "white"
  },
  header: {
    fontWeight: "bold",
    fontSize: "18px",
    textAlign: "center",
    justifyContent : "center",
    alignItems : "center"
  },
  width: {
    maxWidth: "400px",
  },
  subgroup: {
    marginTop : '10px',
    marginBottom : '0px',
    paddingLeft : '0px',
    color : '#DDDDDD'
  }
};

// export default React.memo(PlantOvrColumn);
export default PlantOvrColumn;